import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function About() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <div className="w-full bg-white text-butter-text pt-24 pb-20 md:pt-32 md:snap-start min-h-screen">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12 lg:px-16">
        
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full">
          
          {/* Intro Band */}
          <div className="min-h-[30vh] flex flex-col justify-center mb-16 md:mb-24">
            <motion.span variants={itemVariants} className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-4 block">
              about
            </motion.span>
            <motion.h1 variants={itemVariants} className="font-butter-serif text-[40px] md:text-[56px] text-butter-text leading-tight mb-4 max-w-3xl">
              buttersando, by ivan sridana
            </motion.h1>
            <motion.p variants={itemVariants} className="font-butter-sans text-[18px] md:text-[22px] text-butter-muted italic font-light max-w-2xl">
              a quieter photography space within the same personal world.
            </motion.p>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 lg:gap-24 mb-24 md:mb-32">
            <motion.div variants={itemVariants} className="md:col-span-5 h-[50vh] md:h-[70vh] bg-butter-line rounded-sm overflow-hidden shadow-sm">
              <img 
                src="/about_buttersando_2.jpg" 
                alt="Ivan Sridana detail" 
                // Class 'grayscale' telah dihapus agar foto tampil berwarna
                className="w-full h-full object-cover opacity-90"
              />
            </motion.div>

            <motion.div variants={itemVariants} className="md:col-span-7 flex flex-col justify-center font-butter-sans text-[16px] md:text-[17px] leading-[1.85] text-butter-text space-y-6 md:space-y-8 max-w-xl">
              <p>
                buttersando is my dedicated photography space, built as a softer counterpart to the structured rhythm of my professional life. while my main site speaks through governance, resilience, and systems, this space holds portraits, atmosphere, and carefully observed moments.
              </p>
              <p>
                i’m drawn to images that feel intimate, restrained, and quietly curated. many of them live between softness and clarity, whether through portraiture, visual fragments, or small scenes that stay with me longer than expected.
              </p>
              <p>
                based in jakarta, sometimes bali, buttersando serves as both a personal archive and an open door for selected collaborations.
              </p>
            </motion.div>
          </div>

          {/* Info Blocks */}
          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-butter-line pt-16 mb-24 md:mb-32">
            <div>
              <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-3">visual language</h3>
              <p className="font-butter-serif text-[20px] md:text-[22px] text-butter-text">soft, curated, intimate</p>
            </div>
            <div>
              <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-3">based in</h3>
              <p className="font-butter-serif text-[20px] md:text-[22px] text-butter-text">jakarta, sometimes bali</p>
            </div>
            <div>
              <h3 className="font-butter-sans text-[11px] uppercase tracking-[0.2em] text-butter-muted mb-3">open to</h3>
              <p className="font-butter-serif text-[20px] md:text-[22px] text-butter-text">portraits, creative collaborations, selected visual work</p>
            </div>
          </motion.div>

          {/* CTA Navigasi Bawah */}
          <motion.div variants={itemVariants} className="flex flex-col items-center justify-center text-center bg-[#F8F6F2] py-16 md:py-20 rounded-sm border border-butter-line/50">
            <h2 className="font-butter-serif text-[24px] md:text-[28px] text-butter-text mb-8">
              continue exploring
            </h2>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* Tombol ke Hero Photography */}
              <Link to="/photography" className="font-butter-sans text-[13px] uppercase tracking-[0.15em] bg-butter-dark text-white px-8 py-4 rounded-sm hover:bg-butter-hover transition-colors">
                back to home
              </Link>
              {/* Tombol ke Website Profesional */}
              <Link to="/" className="font-butter-sans text-[13px] uppercase tracking-[0.15em] text-butter-text border border-butter-line px-8 py-4 rounded-sm hover:border-butter-accent hover:text-butter-accent transition-colors">
                visit main site
              </Link>
            </div>
          </motion.div>

        </motion.div>
      </div>
    </div>
  );
}